/* Relentless Souls — theme behaviour.
   Deliberately small: a reveal observer, the mobile nav, and variant sync. */
(function () {
  'use strict';

  /* ── scroll reveal ───────────────────────────────────────── */
  var reveals = document.querySelectorAll('.rise');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        setTimeout(function () { e.target.classList.add('in'); }, (i % 8) * 55);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('in'); });
  }

  /* ── mobile nav ──────────────────────────────────────────── */
  var burger = document.getElementById('burger');
  var nav = document.getElementById('nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.addEventListener('click', function (e) {
      if (!e.target.matches('.navlink')) return;
      nav.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('open')) burger.click();
    });
  }

  /* ── product options → variant id ────────────────────────── */
  var form = document.getElementById('AddToCart');
  var select = document.getElementById('VariantId');
  if (form && select) {
    form.addEventListener('change', function () {
      var chosen = Array.prototype.map.call(
        form.querySelectorAll('input[type=radio]:checked'),
        function (r) { return r.value; }
      ).join(' / ');

      var match = Array.prototype.find.call(select.options, function (o) {
        return o.textContent.trim() === chosen;
      });
      if (!match) return;

      select.value = match.value;
      var price = document.getElementById('price');
      if (price && match.dataset.price) price.textContent = match.dataset.price;

      var btn = form.querySelector('.pdp__add');
      if (btn) {
        btn.disabled = match.disabled;
        btn.textContent = match.disabled ? 'Sold out' : 'Add to cart';
      }
    });
  }

  /* ── product gallery: counter + arrow-key nav ────────────── */
  /* Thumbnails and arrows already work with zero JS (radio/label
     pattern in the CSS) — this only adds the "2 / 6" counter and
     left/right key support. */
  var gallery = document.querySelector('.pdp__gallery');
  if (gallery) {
    var radios = Array.prototype.slice.call(gallery.querySelectorAll('.pdp__radio'));
    var counter = gallery.querySelector('.pdp__count-cur');

    function syncCounter() {
      if (!counter) return;
      var i = radios.findIndex(function (r) { return r.checked; });
      if (i > -1) counter.textContent = String(i + 1);
    }
    radios.forEach(function (r) { r.addEventListener('change', syncCounter); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var i = radios.findIndex(function (r) { return r.checked; });
      if (i === -1) return;
      var next = e.key === 'ArrowRight' ? (i + 1) % radios.length : (i - 1 + radios.length) % radios.length;
      radios[next].checked = true;
      syncCounter();
      e.preventDefault();
    });
  }
})();
